import { axiosClient } from "@/configurations/axios"

import { queryClient } from "@/configurations/react-query"
import { queryOptions } from "@tanstack/react-query"
import he from "he"
import { FAQ_ENDPOINTS, FAQ_KEYS } from "../configs/endpoints"
import { TFAQ } from "../types"

const getExposedFAQList = async (faqCategoryId: number) => {
  const { data } = await axiosClient.get<TFAQ[]>(FAQ_ENDPOINTS.getExposedList, {
    params: { faqCategoryId }
  })
  return data.map<TFAQ>(item => ({
    ...item,
    answerEn: he.decode(item.answerEn),
    answerKo: he.decode(item.answerKo)
  }))
}

export const getExposedFAQListQueryOptions = (faqCategoryId: number) => {
  return queryOptions({
    queryKey: FAQ_KEYS.exposedListWithParams(faqCategoryId),
    queryFn: () => getExposedFAQList(faqCategoryId)
  })
}

export const getExposedFAQListLoader = (faqCategoryId: number) => {
  return queryClient.ensureQueryData(
    getExposedFAQListQueryOptions(faqCategoryId)
  )
}
